import moment from "moment"
import * as d3 from "d3"
import { constantValues } from "src/components/shared/Charts/constant"

export const timeXAxisLabel = (x) => {
  const date = moment(new Date(x))
  const isMidNight = date.hour() === 0 && date.minutes() === 0
  return isMidNight ? date.format("DD MMM") : date.format("hh A")
}

export const yAxisTickFormat = (x, yDomainMax, On, Off) => {
  return x === 0 || x === yDomainMax ? "" : x % 2 === 0 ? On : Off
}

export const drawAxis = (ref, axis) => {
  d3.select(ref).call(axis)
}

export const lineGenerator = (timestamps, data, yScale, xScale, yPosition) => {
  return d3
    .line()
    .x((timestamp: any) => xScale(new Date(timestamp)))
    .y((_: any, i: number) => {
      const value = data?.[i]
      return yScale(generateValueY(yPosition, value))
    })
    .defined((_: any, i: number) => !constantValues?.includes(data?.[i]))(
      timestamps
    )
}

export const generateValueY = (yPosition, value) => {
  return (
    (value === undefined ? value : yPosition) +
    (value === "Off" || value === "No"
      ? 0
      : (value === "On" || value === "Yes") && 1)
  )
}

export const findNearest = (arr, value) => {
  let nearestDatapoint = null;
  let minDifference = Infinity;

  for (const num of arr) {
    const difference = Math.abs(num.ypos - value); // Calculate absolute difference
    if (difference < minDifference) {
      minDifference = difference;
      nearestDatapoint = num;
    }
  }

  return nearestDatapoint;
}